import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';
import EmbeddedYouTubeVideoThumbnail from '@Components/Shared/EmbeddedYouTubeVideoThumbnail';

const ValueInsightPortalView = (props) => {

    return (
        <div className='vip-splash'>
            <div className='main'>
                <div className='container'>
                    <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
                    <div className='wrapper'>
                        <div className='flex-col'>
                            <h1><strong>{props.PageTitle}</strong></h1>
                            <p>{translator.translate('sandhills.tradesites.mvc.vipsplashisyourhub')}</p>
                            <a className='block-btn' href={props.VIPUrl} target='_blank' aria-label={translator.translate('sandhills.tradesites.mvc.vipsplashgetvaluesnow').replace('{0}', props.VIPSplashReplacementValues["Get"]) + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{translator.translate('sandhills.tradesites.mvc.vipsplashgetvaluesnow').replace('{0}', props.VIPSplashReplacementValues["Get"])}</a> 
                        </div>
                        <div className='flex-col col-3'>
                            <div className='vip-video-element'>
                                {props.VIPVideoID ? (
                                    <EmbeddedYouTubeVideoThumbnail
                                        descriptionText={translator.translate('sandhills.tradesites.mvc.learnmoreaboutvip')}
                                        altText={translator.translate('sandhills.tradesites.mvc.learnmoreaboutvip')}
                                        videoId={props.VIPVideoID}
                                    />
                                ): (
                                    <img className='poster-image' src = {props.VIPPosterImage} alt={translator.translate('sandhills.tradesites.mvc.learnmoreaboutvip')} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='main grey-section'>
                <div className='container'>
                    <h2>{translator.translate('sandhills.tradesites.mvc.whatisvalueinsightportal')}</h2>
                    <div className='icon-row'>
                        <ul>
                            <li>
                                <i className='fa-solid fa-dollar-sign'></i>
                                <h3>{translator.translate('sandhills.tradesites.mvc.vipsplashinstantvaluations').replace('{0}', props.VIPSplashReplacementValues["Get"])}</h3>
                                <p>{translator.translate('sandhills.tradesites.mvc.getrealtimepricinginsights')}</p>
                            </li>
                            <li>
                                <i className='fa-solid fa-book'></i>
                                <h3>{translator.translate('sandhills.tradesites.mvc.comprehensivemarketdata')}</h3>
                                <p>{translator.translate('sandhills.tradesites.mvc.accesshistoricalpredictivevalues')}</p>
                            </li>
                            <li>
                                <i className='fa-solid fa-chart-line'></i>
                                <h3>{translator.translate('sandhills.tradesites.mvc.futurevaluepredictions').replace('{0}', props.VIPSplashReplacementValues["Get"])}</h3>
                                <p>{translator.translate('sandhills.tradesites.mvc.plansmarterwithmonthbymonth')}</p>
                            </li>
                            <li>
                                <i className='fa-solid fa-laptop'></i>
                                <h3>{translator.translate('sandhills.tradesites.mvc.onestopvaluationhub').replace('{0}', props.VIPSplashReplacementValues["Get"])}</h3>
                                <p>{translator.translate('sandhills.tradesites.mvc.accessvalutationsinoneplace')}</p>
                            </li>
                            <li>
                                <i className='fa-solid fa-chart-pie'></i>
                                <h3>{translator.translate('sandhills.tradesites.mvc.acceleratedecistionmakingandroi')}</h3>
                                <p>{translator.translate('sandhills.tradesites.mvc.makeinformedbuyingandselling')}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='main'>
                <div className='container'>
                    <h2>{translator.translate('sandhills.tradesites.mvc.howtoheader').replace('{0}', translator.translate('sandhills.tradesites.mvc.vip'))}</h2>
                    <div className='icon-row block'>
                        <ul>
                            <li>
                                <div className="img-container">
                                    <img src={props.VIPImageURLs["LogIn"]} alt=''></img>
                                </div>
                                <h3><strong>{translator.translate('sandhills.tradesites.mvc.stepsemicolon').replace('{0}', 1)}</strong>{translator.translate('sandhills.tradepubwebsite.mvc.login')}</h3>
                                <p>{translator.translate('sandhills.tradesites.mvc.entercredentialsinpopupmenu')}</p>
                            </li>
                            <li>
                                <div className="img-container">
                                    <img src={props.VIPImageURLs["FillBlanks"]} alt=''></img>
                                </div>
                                <h3><strong>{translator.translate('sandhills.tradesites.mvc.stepsemicolon').replace('{0}', 2)}</strong>{translator.translate('sandhills.tradesites.mvc.vipfillintheblanks')}</h3>
                                <p>{translator.translate('sandhills.tradesites.mvc.themorespecificsyouprovide')}</p>
                            </li>
                            <li>
                                <div className="img-container">
                                    <img src={props.VIPImageURLs["Value"]} alt=''></img>
                                </div>
                                <h3><strong>{translator.translate('sandhills.tradesites.mvc.stepsemicolon').replace('{0}', 3)}</strong>{translator.translate('sandhills.tradesites.mvc.findouthowmuchyour').replace('{0}', props.VIPSplashReplacementValues["Find"])}</h3>
                                <p>{translator.translate('sandhills.tradesites.mvc.vipwillreturn').replace('{0}', props.VIPSplashReplacementValues["Find"])}</p>
                            </li>
                            <li>
                                <div className="img-container">
                                    <img src={props.VIPImageURLs["Data"]} alt=''></img>
                                </div>
                                <h3><strong>{translator.translate('sandhills.tradesites.mvc.stepsemicolon').replace('{0}', 4)}</strong>{translator.translate('sandhills.tradesites.mvc.puttrusteddatatowork')}</h3>
                                <ul className='bullet-list'>
                                    <li className='bullet'>{translator.translate('sandhills.tradesites.mvc.makeinformedbuyingorselling')}</li>
                                    <li className='bullet'>{translator.translate('sandhills.tradesites.mvc.saveyourassetsforeasier')}</li>
                                    <li className='bullet'>{translator.translate('sandhills.tradesites.mvc.planaheadvipfuturecast')}</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='vip-banner'>
                <div className='container'>
                    <img src={props.VIPLogo} alt='VIP Logo'></img>
                    <h2>{translator.translate('sandhills.tradesites.mvc.learnhowmuchworth').replace('{0}', props.VIPSplashReplacementValues["Find"])}</h2>
                    <p dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.tradesites.mvc.vipsplashpoweredby')}}></p>
                    <a className='block-btn' href={props.VIPUrl} target='_blank' aria-label={translator.translate('sandhills.tradesites.mvc.vipsplashgetvaluesnow').replace('{0}', props.VIPSplashReplacementValues["Get"]) + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{translator.translate('sandhills.tradesites.mvc.vipsplashgetvaluesnow').replace('{0}', props.VIPSplashReplacementValues["Get"])}</a> 
                </div>
            </div>
            <div className='main'>
                <div className='container'>
                    <h2>{translator.translate('sandhills.tradesites.mvc.valueinsightportalbackedby')}</h2>
                    <div className='logo-container'>
                        <ul>
                            {props.TradeSitesLogos.map((TSLogo) => {
                                return (
                                    <li key={TSLogo.SiteName}>
                                        <a href={TSLogo.SiteUrl} target='_blank' aria-label={TSLogo.SiteName + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                                            <img src={TSLogo.LogoUrl} alt={TSLogo.SiteName + ' Logo'}></img>
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ValueInsightPortalView;
global.ValueInsightPortalView = ValueInsightPortalView;